import type { ButtonHTMLAttributes } from "react";
import styles from "./FeedbackBanner.module.css";
import { cx } from "../cx";
import FeedbackCat from "../brand/feedback-cat.svg?react";
import FeedbackBubble from "../brand/feedback-bubble.svg?react";

export type FeedbackBannerProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children" | "title"> & {
  title: string;
  description: string;
};

/** 의견 배너(Figma FeedbackBanner 875:6639, AC0-315): 최소 높이 68 · 폭은 부모를 채운다. 큰 글씨면 줄바꿈하며 늘어나고(896:6952), 함냥 가면 + 말풍선은 오른쪽 아래 장식. */
export function FeedbackBanner({ title, description, className, ...rest }: FeedbackBannerProps) {
  return (
    <button type="button" className={cx(styles.root, className)} {...rest}>
      <span className={styles.text}>
        <span className={styles.title}>{title}</span>
        <span className={styles.description}>{description}</span>
      </span>
      <span className={styles.artSpace} aria-hidden="true" />
      <FeedbackCat className={styles.cat} aria-hidden="true" />
      <FeedbackBubble className={styles.bubble} aria-hidden="true" />
    </button>
  );
}
